import hljs from 'highlight.js'
import Vue from 'vue'

/* LANGUAGES */
import css from 'highlight.js/lib/languages/css'
import java from 'highlight.js/lib/languages/java'
import javascript from 'highlight.js/lib/languages/javascript'
import php from 'highlight.js/lib/languages/php'
import python from 'highlight.js/lib/languages/python'
import sql from 'highlight.js/lib/languages/sql'

// hljs.configure({
// })

Vue.use(hljs.vuePlugin, {
  languages: {
    css,
    java,
    javascript,
    php,
    python,
    sql
  }
})
